import { call, put, takeEvery } from "redux-saga/effects"

import {
  
  GET_MEMBER_DEFINITIONS,
  ADD_NEW_MEMBER_DEFINITION,
  UPDATE_MEMBER_DEFINITION,
  DELETE_MEMBER_DEFINITION,

} from "./actionTypes"

import {
  getMemberDefinitionsSuccess,
  addMemberDefinitionSuccess,
  updateMemberDefinitionSuccess,
  deleteMemberDefinitionSuccess,
  memberDefinitionsApiError

} from "./actions"

import {
  getMemberDefinitions,
  addNewMemberDefinition,
  updateMemberDefinition,
  deleteMemberDefinition,

} from "../../../helpers/backend_helper/backend_helper"

// MEMBER DEFINITION

function* fetchMemberDefinitions() {
  try {
    const response = yield call(getMemberDefinitions)
    yield put(getMemberDefinitionsSuccess(response))
  } catch (error) {
    yield put(memberDefinitionsApiError(error))
  }
}

function* onAddNewMemberDefinition({ payload: memberDefinition }) {
  try {
    const response = yield call(addNewMemberDefinition, memberDefinition)
    yield put(addMemberDefinitionSuccess(response))
  } catch (error) {

    yield put(memberDefinitionsApiError(error))
  }
}

function* onUpdateMemberDefinition({ payload: memberDefinition }) {
  try {
    const response = yield call(updateMemberDefinition, memberDefinition)
    yield put(updateMemberDefinitionSuccess(response))
  } catch (error) {
    yield put(memberDefinitionsApiError(error))
  }
}

function* onDeleteMemberDefinition({ payload: guid }) {
  try {
    const response = yield call(deleteMemberDefinition, guid)
    yield put(deleteMemberDefinitionSuccess(response))
  } catch (error) {
    yield put(memberDefinitionsApiError(error))
  }
}

function* memberDefinitionSaga() {
  yield takeEvery(GET_MEMBER_DEFINITIONS,fetchMemberDefinitions)
  yield takeEvery(ADD_NEW_MEMBER_DEFINITION,onAddNewMemberDefinition)
  yield takeEvery(UPDATE_MEMBER_DEFINITION,onUpdateMemberDefinition)
  yield takeEvery(DELETE_MEMBER_DEFINITION,onDeleteMemberDefinition)
}

export default memberDefinitionSaga